export const sanitiseInput = (input: string): string => {
  return input.trim().toLowerCase();
};
